<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@renewSubscription">Renew Subscriptions</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="renewSubscriptionForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label i18n="@@promotionCodeLabel">Promotion code</mat-label>
      <input data-testid="promotionCode" matInput id="promotionCode" i18n-placeholder="@@promotionCodePlaceholder" placeholder="Promotion code" name="promotionCode" formControlName="promotionCode" required />
      <mat-error>
        @if (!renewSubscriptionForm.get('promotionCode').valid && renewSubscriptionForm.get('promotionCode').touched) {
          @if (renewSubscriptionForm.get('promotionCode').errors && renewSubscriptionForm.get('promotionCode').errors['required'] || renewSubscriptionForm.get('promotionCode').hasError('whitespace')) {
            <span i18n="@@inValidRequiredField">This field is required</span>
          }
        }
      </mat-error>
    </mat-form-field>
    <div i18n="@@clickToRenewSubscription" class="mat-caption mb-16">If you do not have promo code, click Renew Subscription.</div>
    <button i18n="@@renewSubscriptions" data-testid="renewSubscriptions" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Renew Subscriptions</button>
  </form>
</mat-dialog-content>